export default __webpack_public_path__ + "static/media/ic_faqs.a17110dd.svg";